export enum FrankliEventStatus {
  NEW = 'NEW',
  READ = 'READ',
}
